export const privacyGermanLocalization = {
  routes: {
    legal: 'Rechtliche Informationen',
    'delete-account': 'Konto löschen'
  },
  screens: {
    'delete-account': {
      help: {
        title: 'Unzufrieden oder Fragen?',
        content:
          'Vielleicht finden wir gemeinsam eine Lösung. Schreibe uns eine kurze E-Mail:',
        button: 'Nachricht schreiben'
      },
      delete: {
        title: 'Konto löschen',
        content:
          'Wenn du dein Konto löschst, werden alle deine Beiträge und Daten entfernt. Wir würden dich vermissen!',
        button: 'Konto löschen'
      },
      alerts: {
        'confirm-delete': {
          title: 'Konto unwiderruflich löschen?',
          content:
            'Das Löschen deines Kontos kann nicht rückgängig gemacht werden.',
          confirm: 'Konto löschen',
          cancel: 'Abbrechen'
        }
      }
    }
  },
  components: {
    terms: {
      title: 'Fast fertig!',
      description:
        'Tippe auf „Zustimmen & loslegen“, wenn du mindestens <0>16 Jahre alt</0> bist und die Bedingungen akzeptierst.',
      accept: 'Zustimmen & loslegen'
    }
  }
};

// Guarantees that both translations have the same structure
type PrivacyLocales = typeof privacyGermanLocalization;

export const privacyEnglishLocalization: PrivacyLocales = {
  routes: { legal: 'Legal Information', 'delete-account': 'Delete Account' },
  screens: {
    'delete-account': {
      help: {
        title: 'Unsatisfied or Questions?',
        content:
          'Perhaps we can find a solution together. Send us a short email:',
        button: 'Write Message'
      },
      delete: {
        title: 'Delete Account',
        content:
          'If you delete your account, all your posts and data will be removed. We would miss you!',
        button: 'Delete Account'
      },
      alerts: {
        'confirm-delete': {
          title: 'Permanently delete account?',
          content: 'Deleting your account cannot be undone.',
          confirm: 'Delete Account',
          cancel: 'Cancel'
        }
      }
    }
  },
  components: {
    terms: {
      title: 'Almost done!',
      description:
        'Tap "Agree & Get Started" if you are at least <0>16 years old</0> and accept the terms.',
      accept: 'Agree & Get Started'
    }
  }
};
